import { connect } from 'react-redux';
import FixedHotspotLayer from '../components/FixedHotspotLayer';
import { getFixedHotspots, getScreen } from '../selectors';
import { getScreenStyles } from '../selectors/layout';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    var screen = getScreen(state, isCurrentScreen);
    var screenStyle = getScreenStyles(state, isCurrentScreen);
    return {
        hotspots: getFixedHotspots(state, screen),
        marginLeft: screenStyle.imageMargin.marginLeft,
    };
}
export default connect(mapStateToProps, null)(FixedHotspotLayer);
